<template>

  <div>

    <b-card>
      <h5>Cari data</h5>
      <div class="form-group row">
        <label class="col-2 col-form-label">Flow Modul</label>
        <div class="col-3">
          <ModulTypeComponent 
            :value="filter.moduleType" 
            @value="filter.moduleType = $event"/>
        </div>
      </div>
    </b-card>


    <b-card>
  
      <b-row class="mb-1">
        <b-col class="text-right">
          <b-button 
            v-b-modal.form-flow-approval-modal 
            v-ripple.400="'rgba(255, 255, 255, 0.15)'" 
            variant="primary"
            @click="cleanUpForm()">
            Tambah
          </b-button>
        </b-col>
      </b-row>

      <BaseTable 
        :fields="fields" 
        :items="items" 
        :loading="loading" 
        :rows="pagination.total"
        :perPage="filter.size"
        :currentPage="filter.page"
        :handle-page-change="handlePageChange"
        :detail-item="detailItem"
        :edit-item="editItem"
        :delete-item="deleteItem"
      />

      <FormFlowApproval 
        :page-title="pageTitle"
        :loading="loading" 
        :edit-id="editId"
        :create-item="createItem"
        :update-item="updateItem"
        :formPayload="formPayload"
        @formPayloadFlowApproval="getPayload($event)" />

      <DetailFlowApproval 
        :page-title="pageTitle"
        :result="detail" />
      
    </b-card>

  </div>

  
  
  </template>
  
  <script>
  import _ from "lodash";
  import Ripple from "vue-ripple-directive";
  
  import { FlowApprovalService } from '@/services/flow-approval.service'
  
  import { BCard, BRow, BCol, BButton, BFormInput } from "bootstrap-vue";
  import { successNotification, errorNotification } from "@/auth/utils";
  
  import BaseTable from "@/components/BaseTable.vue";
  import FormFlowApproval from "@/components/FlowApproval/FormFlowApproval.vue";
  import DetailFlowApproval from "@/components/FlowApproval/DetailFlowApproval.vue";
  import ModulTypeComponent from "@/components/Base/ModulTypeComponent.vue";
  
  export default {
    name: 'FlowApprovalPage',
  
    components: {
    BaseTable,
    BCard,
    BRow,
    BCol,
    BButton,
    BFormInput,
    FormFlowApproval,
    DetailFlowApproval,
    ModulTypeComponent
},
  
    directives: {
      Ripple,
    },
  
    watch: {
      filter: {
        handler: _.debounce(function (value) {
          this.fetchData();
        }, 300),
        deep: true,
      },
    },
    
  
    setup () {
      return {
        successNotification,
        errorNotification,
        BaseTable,
      };
    },
  
    data () {
      return {
        pageTitle: 'Daftar Flow Approval',
        items: [],
        detail: Object,
        error: false,
        loading: false,
        pagination: {
          total: 0
        },
        filter: {
          moduleType: '',
          page: 1,
          size: 10,
          flowRulesColumn: 'FLOW_RULES_ID',
          sortDirection: 'DESC'
        },
        fields: [
          {
            key: "no",
            label: "No",
          },
          {
            key: "moduleType",
            label: "Nama Modul",
          },
          {
            key: "roleImplement",
            label: "Implementasi Flow",
          },
          {
            key: "totalApproval",
            label: "Total Approval",
          },
          {
            key: "actions",
            label: "Aksi",
          },
        ],
        editId: null,
        formPayload: Object
      }
    },
  
    methods: {
      cleanUpForm() {
        this.editId = null;
        this.formPayload = {
          moduleType: "",
          roleImplement: 0,
          totalApproval: 0
        };
      },
      async fetchData () {
        this.loading = true
        try {
          const { data } = await FlowApprovalService.findAll(this.filter)
          this.items = data.content
          this.pagination.total = data.total
        } catch (e) {
          this.error = e.message
        } finally {
          this.loading = false
        }
      },
      detailItem(item) {
        let id = item.flowRulesId
        this.$router.push({ name: "flow-master.show", params: { id } });
      },
      editItem(item) {
        this.editId = item.flowRulesId;
        this.formPayload = {
          moduleType: item.moduleType,
          roleImplement: item.roleImplement ? item.roleImplement.roleId : item.roleImplement,
          totalApproval: item.totalApproval,
        };
        this.showFormModal()
      },
      async createItem() {
        this.loading = true
      
        try {
          await FlowApprovalService.create(this.formPayload)
          successNotification(this, "Success", `${this.pageTitle} berhasil dibuat!`);
          this.hideFormModal()
          this.fetchData()
        } catch (e) {
          this.error = e.message
          errorNotification(this, "Oops!", e.message);
        } finally {
          this.loading = false
        }
      },
      async updateItem() {
        this.loading = true
      
        try {
          await FlowApprovalService.update(this.editId, this.formPayload)
          successNotification(this, "Success", `${this.pageTitle} berhasil diubah!`);
          this.hideFormModal()
          this.fetchData()
        } catch (e) {
          this.error = e.message
          errorNotification(this, "Oops!", e.message);
        } finally {
          this.loading = false
        }
      },
      deleteItem(item) {
        this.$swal({
          title: "Anda yakin?",
          text: "Anda yakin ingin menghapus data ini?",
          icon: "warning",
          showCancelButton: true,
          customClass: {
            confirmButton: "btn btn-primary",
            cancelButton: "btn btn-outline-danger ml-1",
          },
          buttonsStyling: false,
        }).then(async (result) => {
          if (result.value) {
            try {
              await FlowApprovalService.delete(item.flowRulesId)
              successNotification(this, "Success", `${this.pageTitle} berhasil dihapus!`);
              this.hideFormModal()
              this.fetchData()
            } catch (e) {
              this.error = e.message
              errorNotification(this, "Oops!", e.message);
            } finally {
              this.loading = false
            }
          }
        });
      },
      getPayload(value) {
        if (value) {
          this.formPayload = value;
        }
      },
      preparePayload() {
        const form = new FormData();
        for (const key in this.formPayload) {
          if (
            this.formPayload.hasOwnProperty(key) &&
            this.formPayload[key] != null
          ) {
            form.append(key, this.formPayload[key]);
          }
        }
  
        return form;
      },
      showFormModal() {
        this.$bvModal.show("form-flow-approval-modal"); 
      },
      hideFormModal() {
        this.$bvModal.hide("form-flow-approval-modal"); 
      },
      handlePageChange(value) {
        this.loading = true
        this.filter.page = value;
      },
    },
  
    created () {
      this.fetchData()
    }
  
  }
  
  </script>